import { PERMISSION } from "@app/modules/roles/constants";
import { JwtSchema, PermissionGroupLevel } from "@core/entities";

export interface LoginFormData {
  email: string;
  password: string;
}

export interface CargoAuthResponse extends JwtSchema {
  access_token: string;
}

export interface PermissionGroupResponse {
  id: number;
  brand_id: number;
  picking_point_permissions: PERMISSION[];
  retailer_permissions: PERMISSION[];
  global_permissions: PERMISSION[];
  name: "Administrador";
  level: PermissionGroupLevel;
  description: null;
}

export enum TWOFACTOR_TYPE {
  GOOGLE_AUTHENTICATOR = "GOOGLE_AUTHENTICATOR",
  PHONE = "PHONE",
}

export type RegisteredTwoFactorMethod = {
  id: number;
  type: TWOFACTOR_TYPE;
  blurredKey?: string;
};
